import { makeStyles } from '@mui/styles';

export const useDeliveryContainerUtilisationChartStyles = makeStyles(() => ({
  wrapper: {
    width: '100%',
    position: 'relative'
  },
  loading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-50px',
    marginLeft: '-50px',
    zIndex: 1
  },
  grid: {
    display: 'grid',
    gap: '1px',
    backgroundColor: '#EBEDF2',
    border: '1px solid #EBEDF2',
    fontFamily: 'Poppins'
  },
  cornerCell: {
    backgroundColor: '#FFFFFF'
  },
  dayHeader: {
    backgroundColor: '#FFFFFF',
    padding: '8px 4px',
    textAlign: 'center',
    fontSize: '11px',
    fontWeight: 500,
    color: '#555',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  groupLabel: {
    backgroundColor: '#FFFFFF',
    padding: '0 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '12px',
    fontWeight: 500,
    overflow: 'hidden'
  },
  // Matches the capacity chart's row label: the ellipsis has to sit on the
  // text's own box rather than the flex container, or an over-long name is
  // clipped at the start with no ellipsis.
  groupLabelText: {
    minWidth: 0,
    textAlign: 'right',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  // Material-UI defaults its tooltip to 10px, where the capacity chart above gets Chart.js's
  // 12px default. Match it so the two charts' tooltips read the same.
  tooltip: {
    fontSize: '12px'
  },
  cell: {
    minHeight: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '11px',
    fontWeight: 500,
    cursor: 'default',
    transition: 'transform 50ms ease',
    '&:hover': {
      outline: '2px solid rgba(0,0,0,0.4)',
      outlineOffset: '-2px',
      zIndex: 1
    }
  }
}));
